<template>
  <div class="article">
    <div class="title">洪子晴爵士应邀出席2025年云南省西双版纳傣族自治州产业招商引资推介会</div>
    <div class="info">作者：晴天集团 发布于：2025-06-13 20:48</div>
    <br>
    <img src="@/assets/img/article/0613/1.webp" alt="">
    <p>2025 年 4 月 26 日，云南省西双版纳傣族自治州产业招商引资推介会在深圳市盛大举行，来自各界的商业精英、企业家代表齐聚一堂，共同聚焦西双版纳州的产业发展新机遇。备受尊敬的洪子晴爵士作为特邀嘉宾出席了此次盛会，并在会上发表了重要讲话，为西双版纳州的产业发展和招商引资工作建言献策。</p>
    <p>云南省西双版纳傣族自治州委书记朱家伟出席推介会并致辞，晴天集团董事局主席洪子晴爵士，深圳市文化创意行业协会驻会会长陈鹤平、广东振远文化集团董事长梁振运等出席推介会并发言。</p>
    <img src="@/assets/img/article/0613/2.webp" alt="">
    <p class="img-alt">云南省西双版纳傣族自治州委书记朱家伟同志发表致词</p>
    <p>朱家伟书记表示，西双版纳自然人文独特、发展潜力巨大，特别是今年3月，习近平总书记再次到云南考察，寄予了“发挥比较优势，推动产业转型升级”等殷切嘱托，全州上下备受鼓舞、干劲十足。希望各位企业家情系西双版纳、选择西双版纳、携手西双版纳，成为奋进未来的“最好合伙人”、彼此成就的“命运共同体”。西双版纳的干部职工将努力营造优质、高效、便捷的营商环境，当好企业发展的“金牌服务员”。</p>
    <img src="@/assets/img/article/0613/3.webp" alt="">
    <p class="img-alt">晴天集团董事局主席洪子晴爵士代表企业家发言</p>
    <br>
    <img src="@/assets/img/article/0613/4.webp" alt="">
    <p class="img-alt">晴天集团董事局主席洪子晴爵士代表企业家发言</p>
    <p>洪子晴爵士发言讲到，我是金运佳集团、深圳晴天集团主席、我集团是一个投资集团旗下投资了十几个不同板块的产业、新能源汽车、智能停车场、文化媒体、AI 数字人科技、大农业云平台、珠宝云平台、生命科技大健康、无人机项目、3D彩印 ）、我更参与投资多家香港与美国上市公司等领域。西双版纳之美既是自然的馈赠，也是人文的传承，深圳特区之美是敢闯敢拼、创新涌动的拓荒精神，推动两地进一步加强对接、深化交流，共同绘就合作共赢之美。</p>
    <p>在推介会上，洪子晴爵士对西双版纳州的独特优势给予了高度评价。她指出，西双版纳州作为中国面向东南亚的重要门户，拥有得天独厚的地理位置，是连接中国与东盟市场的关键枢纽。其丰富的自然资源，如广袤的热带雨林、多样的生物物种，为发展生态农业、生物医药、康养旅游等产业提供了坚实的基础。同时，西双版纳州深厚的民族文化底蕴，傣族、哈尼族等多个少数民族的独特风情，构成了极具吸引力的文化旅游资源，在文旅融合发展方面潜力巨大。</p>
    <p>谈及产业发展，洪子晴爵士建议，西双版纳州应充分利用自身优势，构建特色产业集群。在农业领域，可依托当地丰富的热带水果、茶叶等资源，发展现代化、标准化的农业种植与深加工产业，打造具有地域特色的农产品品牌，提升产品附加值，通过电商、物流等渠道拓展国内外市场。在文旅产业方面，要注重文化内涵的挖掘与创新，打造具有国际影响力的文旅项目，结合智慧旅游建设，提升游客体验。同时，借助中老铁路开通的契机，大力发展口岸经济，加强与周边国家的贸易往来，推动跨境电商、现代物流等产业的繁荣。</p>
    <p>洪子晴爵士还强调了营商环境对于招商引资的重要性。她表示，一个良好的营商环境是吸引企业投资的关键因素。西双版纳州应持续优化政务服务，简化行政审批流程，提高政策透明度和稳定性，为企业提供全方位的支持与保障。此外，加强基础设施建设，提升城市综合承载能力，也是吸引优质企业入驻的必要条件。</p>
    <p>此次推介会为西双版纳州与外界搭建了一个交流合作的平台，洪子晴爵士的讲话为西双版纳州的产业发展提供了新的思路和视角。相信在各方的共同努力下，西双版纳州将以此次推介会为契机，吸引更多的投资与资源，推动产业升级，实现经济的高质量发展，在新时代的发展浪潮中绽放出更加耀眼的光芒。</p>
    <img src="@/assets/img/article/0613/5.webp" alt="">
    <p>州、县（市）政府及西双版纳文化旅游投资开发有限公司分别与15家企业举行了合作签约会上，州、县（市）政府及西双版纳文化旅游投资开发有限公司分别与15家企业举行了合作签约。考察团一行还到大芬油画村、丰隆深港科技园、深圳大运AI小镇、晴天集团、广东振远文化集团有限公司进行考察学习。</p>
    <p>西双版纳州徐健斌、胡向京，各县（市）及州级有关部门主要负责同志，深圳市120余名企业家参加相关活动。</p>
  </div>
</template>

<script>
export default {
  name: '1',
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.article{
  width: 70%;
  margin: 20px auto;
  font-family: $font-family;
  .title{
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
  }

  .info{
    height: 28px;
    line-height: 28px;
    border-bottom: 1px #e8e8e8 solid;
    margin: 0;
    text-align: center;
    font-size: 0.8rem;
  }

  p{
    font-size: $content-font-size;
    color: #000000;
    line-height: 2;
    margin: 20px 0;
  }

  img{
    width: 60%;
    margin-left: 20%;
  }

  .img-alt{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 10px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }

  .img-alt-content{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 5px;
    padding-bottom: 15px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .article{
    width: 90%;
    margin: 20px auto;
    .title{
      padding-top: 10px;
      padding-bottom: 8px;
      font-size: 1.1rem;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 80%;
      margin-left: 10%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      color: #2f2e2e;
      padding-top: 5px;
      font-size: 0.8rem;
    }
    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.8rem;
    }
  }
}

@media (max-width: 480px) {
  .article{
    width: 100vw;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 20px auto;
    .title{
      padding-top: 10px;
      padding-bottom: 8px;
      font-size: 1.1rem;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 100%;
      margin: 0;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      font-size: 0.7rem;
      margin: 6px 0;
      color: #666;
    }
  }
}
</style>
